// Lazily injects the Carrot Quest loader (#CarrotTemplate) into the page and
// defines the App.carrot auth hook that the loader's onload calls. Standalone
// so utils/intercom.js and the support footer can both reuse it without
// depending on each other.
export const injectCarrot = () => {
  if (typeof carrotquest !== 'undefined') {
    return;
  }

  const template = document.querySelector('#CarrotTemplate');

  if (!template) {
    return;
  }

  window.App = window.App || {};

  window.App.carrot = () => {
    if (window.App.carrot_userId && window.App.carrot_userHash) {
      carrotquest.auth(window.App.carrot_userId || '', window.App.carrot_userHash || '');
    }
  };

  document.body.appendChild(document.importNode(template.content, true));
};
